import styled from "styled-components";
import { ProgressBar, ProgressBarProps } from "./index";

export const ProgressBarInner = styled.div<{
  percent: number;
  color: string;
}>`
  height: 100%;
  width: ${(p) => `${p.percent}%`};
  transition: all 0.2s ease-in-out;
  background: ${(p) => p.color};
  border-radius: 27px;
`;

export const ProgressBarWrapper = styled.div<{
  width: string;
  height: string;
  background: string;
}>`
  width: ${(p) => p.width};
  height: ${(p) => p.height};
  background: ${(p) => p.background};
  border-radius: 27px;
  ${ProgressBarInner} {
    height: ${(p) => p.height};
  }
`;
